<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariAllowanceIndex'
}
</script>
